(function(){
  'use strict';
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  /* Countdown to next cut-off, in Irish time, weekdays only */
  function dublinParts(d){
    var f=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Dublin',weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false});
    var p={};f.formatToParts(d).forEach(function(x){p[x.type]=x.value;});
    return {wd:p.weekday,h:+p.hour%24,m:+p.minute,s:+p.second};
  }
  function secondsLeft(cut){
    var c=cut.split(':'),ch=+c[0],cm=+c[1]||0,t=dublinParts(new Date());
    var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],wd=days.indexOf(t.wd);
    var nowS=t.h*3600+t.m*60+t.s,cutS=ch*3600+cm*60;
    if(wd>=1&&wd<=5&&nowS<cutS){return cutS-nowS;}
    var d=wd,n=0;do{d=(d+1)%7;n++;}while(d===0||d===6);
    return (86400-nowS)+(n-1)*86400+cutS;
  }
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    $$('[data-ss-countdown]').forEach(function(el){
      var s=secondsLeft(el.getAttribute('data-ss-countdown')||'18:00');
      if(s>=86400){el.textContent=Math.floor(s/86400)+'d '+pad(Math.floor(s%86400/3600))+'h '+pad(Math.floor(s%3600/60))+'m';}
      else{el.textContent=pad(Math.floor(s/3600))+':'+pad(Math.floor(s%3600/60))+':'+pad(s%60);}
    });
  }
  tick();setInterval(tick,1000);

  /* Quantity steppers */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-ss-step]');if(!b)return;
    e.preventDefault();
    var w=b.closest('[data-ss-qty]'),i=w&&w.querySelector('input');if(!i)return;
    var max=parseInt(i.getAttribute('max'),10)||9999,v=(parseInt(i.value,10)||1)+parseInt(b.getAttribute('data-ss-step'),10);
    i.value=Math.min(max,Math.max(1,v));
    i.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* Ajax add to cart */
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches||!f.matches('[data-ss-ajax-cart]'))return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'),label=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;}
    fetch((window.routes&&window.routes.cartAddUrl||'/cart/add')+'.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(){
        if(btn){btn.classList.add('is-added');btn.innerHTML='Added ✓';}
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));
        return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){$$('.header__cart-count').forEach(function(n){n.textContent=c.item_count;});});
      })
      .catch(function(err){if(btn){btn.innerHTML=(err&&err.description)||'Not available';}})
      .then(function(){setTimeout(function(){if(btn){btn.disabled=false;btn.classList.remove('is-added');btn.innerHTML=label;}},2200);});
  });

  /* Mega menu */
  function initNav(){
    $$('[data-ss-nav-item]').forEach(function(item){
      if(item.__ss)return;item.__ss=1;
      if(!item.querySelector('.ss-mega'))return;
      var t,btn=item.querySelector('[aria-expanded]');
      function open(){clearTimeout(t);$$('[data-ss-nav-item].is-open').forEach(function(o){if(o!==item){o.classList.remove('is-open');var b=o.querySelector('[aria-expanded]');if(b)b.setAttribute('aria-expanded','false');}});item.classList.add('is-open');if(btn)btn.setAttribute('aria-expanded','true');}
      function close(){t=setTimeout(function(){item.classList.remove('is-open');if(btn)btn.setAttribute('aria-expanded','false');},120);}
      item.addEventListener('mouseenter',open);item.addEventListener('mouseleave',close);
      if(btn)btn.addEventListener('click',function(e){if(!item.classList.contains('is-open')){e.preventDefault();open();}});
    });
  }
  initNav();document.addEventListener('DOMContentLoaded',initNav);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')$$('[data-ss-nav-item].is-open').forEach(function(o){o.classList.remove('is-open');});});

  /* Hero slider */
  $$('[data-ss-hero]').forEach(function(h){
    var slides=$$('.ss-hero__slide',h),dots=$$('.ss-hero__dot',h),i=0,timer;
    if(slides.length<2)return;
    function go(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,k){s.classList.toggle('is-active',k===i);});dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);d.setAttribute('aria-current',k===i?'true':'false');});}
    function auto(){clearInterval(timer);timer=setInterval(function(){go(i+1);},7000);}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);auto();});});
    h.addEventListener('mouseenter',function(){clearInterval(timer);});h.addEventListener('mouseleave',auto);
    auto();
  });

  /* Reviews tabs + paging */
  $$('[data-ss-reviews]').forEach(function(w){
    var cards=$$('.ss-review',w),tabs=$$('.ss-tab',w),src='all',off=0,per=3;
    function pool(){return cards.filter(function(c){return src==='all'||c.getAttribute('data-source')===src;});}
    function render(){var p=pool();cards.forEach(function(c){c.hidden=true;});for(var k=0;k<Math.min(per,p.length);k++){p[(off+k)%p.length].hidden=false;}}
    tabs.forEach(function(t){t.addEventListener('click',function(){src=t.getAttribute('data-source');off=0;tabs.forEach(function(x){x.setAttribute('aria-selected',x===t?'true':'false');});render();});});
    var prev=w.querySelector('[data-ss-prev]'),next=w.querySelector('[data-ss-next]');
    if(prev)prev.addEventListener('click',function(){var n=pool().length;off=(off-per+n*10)%n;render();});
    if(next)next.addEventListener('click',function(){var n=pool().length;off=(off+per)%n;render();});
    render();
  });

  /* Product gallery */
  $$('[data-ss-gallery]').forEach(function(g){
    var main=g.querySelector('.ss-gallery__main img');
    $$('.ss-gallery__thumb',g).forEach(function(t){t.addEventListener('click',function(){if(main){main.src=t.getAttribute('data-src');main.removeAttribute('srcset');}$$('.ss-gallery__thumb',g).forEach(function(x){x.classList.toggle('is-active',x===t);});});});
  });

  /* Product variant select (multi-variant products) */
  $$('[data-ss-variant-select]').forEach(function(sel){
    sel.addEventListener('change',function(){
      var o=sel.options[sel.selectedIndex],box=sel.closest('[data-ss-buybox]');if(!box)return;
      $$('[data-ss-price]',box).forEach(function(p){p.textContent=o.getAttribute('data-price');p.setAttribute('bss-b2b-variant-id',o.value);});
      var btn=box.querySelector('[type=submit]');if(btn){btn.disabled=o.getAttribute('data-available')!=='true';}
      if(window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u);}
    });
  });

  /* Collection filters: submit on change */
  $$('[data-ss-filters]').forEach(function(f){f.addEventListener('change',function(){f.submit();});});
  $$('[data-ss-sort]').forEach(function(s){s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u;});});

  /* Safety net for BSS B2B: BSS hides prices until it has applied trade pricing.
     If it has not revealed them after 3s, show the normal price, and hide an unfilled trade line. */
  setTimeout(function(){
    $$('.ss [bss-b2b-product-id], .ss [bss-b2b-variant-id], .ss [bss-b2b-product-price]').forEach(function(el){
      if(getComputedStyle(el).visibility==='hidden'){el.style.visibility='visible';}
    });
    $$('.ss .bss-save-to-cp').forEach(function(el){
      var line=el.closest('.ss-trade-line'),main=document.querySelector('.ss [data-ss-price]');
      if(line&&(!el.textContent.trim()||(main&&el.textContent.trim()===main.textContent.trim()))){line.style.display='none';}
    });
  },3000);
})();
